module.exports = __webpack_public_path__ + "static/media/essential-oil-chemistry-handbook.0ea61cc6.pdf";